import axios from '@/utils/request';

export default {
    // 客户端接口
    getNewsList(categoryId) {
        return axios.get('/news/client/list', { params: { categoryId } });
    },
    getNewsDetail(id) {
        return axios.get(`/news/client/detail/${id}`);
    },

    // 侧边栏接口
    getNotifications() {
        return axios.get('/news/sidebar/notifications');
    },
    getNotification(id) {
        return axios.get(`/news/sidebar/notification/${id}`);
    },

    // 管理端接口
    getAdminPage(params) {
        return axios.get('/news/admin/page', { params });
    },
    addNews(data) {
        return axios.post('/news/admin/add', data);
    },
    updateNews(data) {
        return axios.put('/news/admin/update', data);
    },
    deleteNews(id) {
        return axios.delete(`/news/admin/delete/${id}`);
    },

    // 侧边栏管理接口
    addNotification(data) {
        return axios.post('/news/sidebar/admin/notification/add', data);
    },
    deleteNotification(id) {
        return axios.delete(`/news/sidebar/admin/notification/delete/${id}`);
    },

    // 政策法规接口
    getPolicyPage(params) {
        return axios.get('/policy/page', { params });
    },
    getPolicyCountsByYear() {
        return axios.get('/policy/counts-by-year');
    },
    getPolicyDetail(id) {
        return axios.get(`/policy/detail/${id}`);
    },
    addPolicy(data) {
        return axios.post('/policy/add', data);
    },
    updatePolicy(data) {
        return axios.post('/policy/update', data);
    },
    deletePolicy(id) {
        return axios.delete(`/policy/delete/${id}`);
    },
    getPolicyList() {
        return axios.get('/policy/list');
    },
    uploadFile(formData) {
        return axios.post('/minio/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }
};
